/**
 * @file The pie insight component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InsightBreeze } from '../insight-base/insight-breeze';
import { InsightProvider } from '../insight-provider';
import { InsightService } from '../../insights/insight.service';
import { LocalisationService } from '../../core/localisation.service';
import { ResourceService } from '../../resource.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
/**
 * Insight component that shows a Pie Chart.
 */
var InsightPieComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InsightPieComponent, _super);
    /**
     * Constructs an InsightPieComponent.
     * @param configurationsService A service that manages the configuration for components.
     * @param provider A provider that contains extra information such as configuration data.
     */
    function InsightPieComponent(resourceService, provider, insightService, localisationService, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService, eventsService) || this;
        _this.alertsService = alertsService;
        // Data object for insight pie component
        _this.data = {
            items: []
        };
        return _this;
    }
    // Calculate total of all percentages.
    InsightPieComponent.prototype.totalPercentage = function () {
        return this.data.items.reduce(function (a, b) { return a + b.percentage; }, 0);
    };
    /**
     * Set the table insight data
     */
    InsightPieComponent.prototype.setData = function (items) {
        if (items.length > 0) {
            // Store data
            this.data['items'] = items;
            // Set ready
            this.setState('ready');
        }
        else {
            this.setState('nodata');
        }
    };
    /**
     * Calculate the distance for a stroke-dasharray and stroke-dashoffset in the circle of a pie insight.
     * @param radius The radius of the circle.
     * @param percentage The percentage of the distance that will be returned.
     * @returns The given percentage of the cirkels circumference.
     */
    InsightPieComponent.prototype.calculateDistance = function (radius, percentage) {
        // Compute circumference = 2 * pi * r (the distance around the circle).
        var distance = Math.PI * radius * 2;
        return (percentage / 100) * distance;
    };
    /**
     * Summarize the percentage of all checklist on and before the given index.
     * @param index The index of the last item to summarize.
     * @returns The sum of the selected checklist.
     */
    InsightPieComponent.prototype.sumPercentageUpToIndex = function (index) {
        var rest = 0;
        for (var i = 0; i <= index; i += 1) {
            rest += this.data.items[i].percentage;
        }
        return rest;
    };
    return InsightPieComponent;
}(InsightBreeze));
export { InsightPieComponent };
